import { useAuth } from "@/lib/auth-context";
import CompradorInicio from "./comprador/inicio";
import ProdutorInicio from "./produtor/inicio";

/**
 * A porta única do módulo /mercado.
 *
 * ⚠️ MESMA ROTA para os dois lados. Quem decide o conteúdo é `organizations.tipo`,
 * aqui — o registry de módulos não ganhou filtro por tipo, e a visibilidade continua
 * saindo de `modules_enabled`. Dois caminhos de URL para "a home do Mercado" seriam
 * dois lugares para o link errado apontar.
 */
export default function MercadoPage() {
  const { user } = useAuth();
  return user?.orgTipo === "COMPRADOR" ? <CompradorInicio /> : <ProdutorInicio />;
}
